// seller-service profile paths (relative to VITE_SELLER_API_URL, under the /api prefix).
export const profileEndpointPaths = {
  SELLER_ME: '/api/sellers/me',
  SELLER_OWNER_PROFILE: '/api/sellers/me/owner-profile',
} as const
